import {
  Container,
  DestroyOptions,
  Graphics,
  Point,
  Sprite,
  Text,
  Ticker,
} from "pixi.js";
import { LoadingProgress } from "../loading/AssetLoader";
import gsap from "gsap";
import { DEBUG } from "../AppConfig";

class LoadScreen extends Container {
  private loadingText: Text;
  private loadingAnimation: gsap.core.Timeline;

  private debug: boolean;
  private dbgText: Text;

  private dimensions = new Point(1920, 1080);

  constructor() {
    super();

    this.debug = DEBUG;

    this.loadingText = new Text({
      text: "Loading ...",
      style: {
        fill: 0xffffff,
        fontSize: 50,
        fontWeight: "lighter",
        align: "right",
      },
    });
    this.loadingText.alpha = 0;
    this.loadingText.anchor.set(0.5, 0.5);
    this.loadingText.position.set(this.dimensions.x / 2, this.dimensions.y / 2);
    this.addChild(this.loadingText);

    this.loadingAnimation = gsap.timeline({
      repeatRefresh: true,
      repeat: -1,
    });

    this.loadingAnimation
      .to(this.loadingText, {
        pixi: {
          alpha: 1,
        },
        duration: 1,
        ease: "sine.inOut",
      })
      .to(this.loadingText, {
        pixi: {
          alpha: 0.3,
        },
        duration: 1,
        ease: "sine.inOut",
      });

    this.dbgText = new Text({
      text: "",
      style: {
        fill: 0xffffff,
        fontSize: 17,
        fontWeight: "lighter",
        align: "right",
      },
    });
    this.dbgText.anchor.set(1, 1);
    this.dbgText.position.set(this.dimensions.x, this.dimensions.y);
    if (this.debug) {
      this.addChild(this.dbgText);
    }
  }

  public onData = (data: LoadingProgress): void => {
    if (!this.debug) return;

    // this.dbgText.text = `Loading...\n${data.currentSection}\n ${
    //   data.sectionsLoaded + 1
    // } of ${data.sectionsToLoad} - ${(data.sectionProgress * 100).toFixed(2)}`;
    this.dbgText.text = `Loading...\n${data.currentSection}\n${(data.sectionProgress * 100).toFixed(2)}`;
  };

  public onError = (error: Error): void => {
    // Stop the loading animation
    this.loadingAnimation.kill();

    // Update the text to show error
    this.loadingText.text = "Loading error!";
    this.loadingText.style.fill = 0xff0000; // Red color
    this.loadingText.alpha = 1;

    // Update debug text if enabled
    if (this.debug) {
      this.dbgText.text = `Error: ${error.message}`;
    }
  };

  public finish = () => {
    // Ticker.shared.remove(this.onTick);
  };

  destroy = (options?: DestroyOptions) => {
    // Ticker.shared.remove(this.onTick);
    this.loadingAnimation.kill();
    super.destroy(options);
  };
}

export default LoadScreen;
